import { ReactComponent as InstaIcon } from '../assets/icons/icon_instagram.svg';
import { ReactComponent as FacebookIcon } from '../assets/icons/icon_facebook.svg';
import { ReactComponent as WebIcon } from '../assets/icons/icon_website.svg';
import { ReactComponent as TwitterIcon } from '../assets/icons/icon_twitter.svg';

export enum MediaAccount {
    WEB = 'website', INSTA = 'instagram', FACEBOOK = 'facebook', TWITTER = 'twitter'
}

export const getIconForSocialMediaSlug = (slug: string) => {
    switch(slug) {
        case 'instagram':
            return InstaIcon;
        case 'facebook':
            return FacebookIcon;
        case 'website':
            return WebIcon;
        case 'twitter':
            return TwitterIcon;
    }

    console.warn(`No icon for slug ${slug}`);

    return WebIcon;
};

export default getIconForSocialMediaSlug;
